import { isString, get, omitBy, isNil } from 'lodash-es';
import moment from 'moment';
import type { CoreTypes } from '../../core';
import type { Resource } from '../types/resources';
import { getDivisionId, hasDivisionId, type DivisionScope } from './common';

/**
 * @deprecated This is only used for SCS. can be removed when scs use v2
 */
export default (
  resources: any[],
  domain?: DivisionScope
): Resource[] => {
  if (!Array.isArray(resources))
    throw new Error('(SS12000::To::Resources) Resources input is not of array type', { cause: 'invalid_input' });

  if (!resources.every((resource) => isString(resource) || isString(get(resource, 'id'))))
    throw new Error('(SS12000::To::Resources) Some resources are missing "id" values', { cause: 'invalid_input' });

  if (!domain && !resources.every((resource) => !isString(resource) && hasDivisionId(resource)))
    throw new Error('(SS12000::To::Resources) Some top layer resources are missing division values', { cause: 'invalid_input' });

  return resources.map((resource) => ({
    id: `${ getDivisionId(resource, domain) }.${ isString(resource) ? resource : resource.id }`,
    ...!isString(resource) && {
      meta: {
        created:  moment(resource.createdAt).toISOString(),
        modified: moment(resource.updatedAt).toISOString()
      },
      /*
        Optionally add the following properties
      */

      ...omitBy({
        foreignId: resource.ids,
      }, isNil)
    }
  }));
};
